<script setup>
import { useMenuStore } from "@stores/menu";
import { useSettingsStore } from "@stores/settings";

const { settings } = useSettingsStore();
const menuStore = useMenuStore();

const logoUrl = settings.general_logo;

const props = defineProps({
  icon: {
    type: Boolean,
  },
});
</script>

<template>
  <NuxtLink
    to="/"
    class="flex items-center sm:w-auto"
    @click="menuStore.modalClose()"
  >
    <img
      :src="logoUrl"
      class="object-contain max-w-full max-h-full"
    />
  </NuxtLink>
</template>
